import React, { useState, useEffect } from 'react';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import y from 'y4/Utils';

const LoadingIconButton = ({
  loadingText,
  loadingIcon,
  icon,
  onClick,
  ...rest
}) => {
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    if (isLoading) {
      var result = onClick();
      Promise.resolve(result).then(() => {
        setLoading(false);
      });
    }
  }, [isLoading]);

  const handleClick = () => setLoading(true);
  return (
    <IconButton
      {...rest}
      disabled={isLoading}
      icon={isLoading ? y.et(loadingIcon, icon) : icon}
      onClick={!isLoading ? handleClick : null}
    >
      {isLoading ? y.et(loadingText, rest.children) : rest.children}
    </IconButton>
  );
};

LoadingIconButton.propTypes = {
  loadingText: PropTypes.string,
  loadingIcon: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func
};

export default LoadingIconButton;
